import BadgeNext from "ds/components/BadgeNext";
import { BadgeVariants } from "ds/components/BadgeNext/types";

import { EvaluationRecordOutcomeStatus } from "./types";

type EvaluationRecordOutcomeConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const EVALUATION_RECORD_OUTCOMES: Record<
  EvaluationRecordOutcomeStatus,
  EvaluationRecordOutcomeConfig
> = {
  [EvaluationRecordOutcomeStatus.Error]: { variant: "red", text: "Error" },
  [EvaluationRecordOutcomeStatus.Deny]: { variant: "red", text: "Deny" },
  [EvaluationRecordOutcomeStatus.Reject]: { variant: "red", text: "Reject" },
  [EvaluationRecordOutcomeStatus.Warning]: { variant: "yellow", text: "Warning" },
  [EvaluationRecordOutcomeStatus.Warn]: { variant: "yellow", text: "Warn" },
  [EvaluationRecordOutcomeStatus.Successful]: { variant: "green", text: "Successful" },
  [EvaluationRecordOutcomeStatus.Approve]: { variant: "green", text: "Approve" },
  [EvaluationRecordOutcomeStatus.Allow]: { variant: "green", text: "Allow" },
  [EvaluationRecordOutcomeStatus.Admin]: { variant: "green", text: "Admin" },
  [EvaluationRecordOutcomeStatus.Idle]: { variant: "blue", text: "Idle" },
  [EvaluationRecordOutcomeStatus.Info]: { variant: "blue", text: "Info" },
  [EvaluationRecordOutcomeStatus.Track]: { variant: "blue", text: "Track" },
  [EvaluationRecordOutcomeStatus.Propose]: { variant: "blue", text: "Propose" },
  [EvaluationRecordOutcomeStatus.Read]: { variant: "blue", text: "Read" },
  [EvaluationRecordOutcomeStatus.Trigger]: { variant: "blue", text: "Trigger" },
  [EvaluationRecordOutcomeStatus.Write]: { variant: "blue", text: "Write" },
  [EvaluationRecordOutcomeStatus.Webhook]: { variant: "turquoise", text: "Webhook" },
  [EvaluationRecordOutcomeStatus.PullRequest]: { variant: "turquoise", text: "Pull Request" },
  [EvaluationRecordOutcomeStatus.Inbox]: { variant: "turquoise", text: "Inbox" },
  [EvaluationRecordOutcomeStatus.Slack]: { variant: "turquoise", text: "Slack" },
  [EvaluationRecordOutcomeStatus.Multiple]: { variant: "gray", text: "Multiple" },
  [EvaluationRecordOutcomeStatus.Ignore]: { variant: "gray", text: "Ignore" },
  [EvaluationRecordOutcomeStatus.None]: { variant: "gray", text: "None" },
  [EvaluationRecordOutcomeStatus.Undecided]: { variant: "gray", text: "Undecided" },
};

type EvaluationRecordStatusBadgeProps = {
  status: EvaluationRecordOutcomeStatus;
  className?: string;
  text: string;
};

const EvaluationRecordStatusBadge = ({
  status,
  className,
  text,
}: EvaluationRecordStatusBadgeProps) => {
  return (
    <BadgeNext
      variant={EVALUATION_RECORD_OUTCOMES[status].variant}
      type="strong"
      className={className}
      text={text}
    />
  );
};

export default EvaluationRecordStatusBadge;
